<div class="mb-3">
  <div *ngIf="detailInfo.inputContentDatas as inputContentDatas">
    <app-field-title [titleInfo]="detailInfo" [formControlObj]="formControlObj">
      <fieldset class="d-flex flex-row flex-wrap" id="group" required>
        <div
          class="d-flex flex-row me-1"
          [class.w-100]="inputContentData.extraValueType === InputContentDataExtraValueType.Textarea"
          [class.flex-column]="inputContentData.extraValueType === InputContentDataExtraValueType.Textarea"
          *ngFor="let inputContentData of inputContentDatas"
        >
          <label class="form-check-label">
            <input
              type="radio"
              class="me-1 form-check-input"
              [value]="inputContentData.key"
              [(ngModel)]="dataKey"
              (ngModelChange)="selectOption()"
              [disabled]="formControlObj.disabled"
              [name]="detailInfo.evideInputContentGuid + '-' + radioGroupUid"
            />{{ inputContentData.value }}
            <input
              class="bottom-border-input form-control"
              type="text"
              [ngModelOptions]="{ standalone: true }"
              *ngIf="
                inputContentData.extraValueType ===
                  InputContentDataExtraValueType.Textbox &&
                dataKey === inputContentData.key
              "
              [(ngModel)]="dataStringExtraValue"
              (ngModelChange)="selectOption()"
              [disabled]="formControlObj.disabled"
            />
          </label>
          <textarea
            class="form-control mt-1"
            style="white-space: pre-line"
            rows="3"
            [ngModelOptions]="{ standalone: true }"
            *ngIf="
              inputContentData.extraValueType ===
                InputContentDataExtraValueType.Textarea &&
              dataKey === inputContentData.key
            "
            [(ngModel)]="dataStringExtraValue"
            (ngModelChange)="selectOption()"
            [disabled]="formControlObj.disabled"
          ></textarea>
        </div>
      </fieldset>
    </app-field-title>
  </div>
</div>
